export default __webpack_public_path__ + "static/media/it900-a32-2.6f3db9e2.jpg";